import React from 'react';

export const CloseIcon = ({ nameOfClass }) => (
    <svg className={nameOfClass} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path className="st0" d="M14,13l-5-5l5-5c0.3-0.3,0.3-0.8,0-1.1S13.3,1.7,13,2l-5,5L3,2C2.7,1.7,2.2,1.7,2,2S1.7,2.7,2,3l5,5l-5,5 c-0.3,0.3-0.3,0.8,0,1.1c0.1,0.1,0.3,0.2,0.5,0.2S2.9,14.2,3,14l5-5l5,5c0.1,0.1,0.3,0.2,0.5,0.2s0.4-0.1,0.5-0.2 C14.3,13.8,14.3,13.3,14,13z"/>
    </svg>
);
